import type { TFunction } from 'i18next';

import { Gender } from '@src/shared';

import type { BankDetails } from '@entities/agent-contract';

import type {
  MVPProfileCodeData,
  MVPProfileWorkData,
  ProfilePersonalData,
} from '../model';

export const getBankDetailsTranslations = (
  t: TFunction
): Record<keyof BankDetails, string> => ({
  bic: t('AGENT_PROFILE:labels.bic'),
  nameBank: t('AGENT_PROFILE:labels.bankName'),
  corAccount: t('AGENT_PROFILE:labels.corAccount'),
  bankAccount: t('AGENT_PROFILE:labels.bankAccount'),
});

export const getMVPCodeDataTranslations = (
  t: TFunction
): Partial<Record<keyof MVPProfileCodeData, string>> => ({
  lnrCode7778: t('AGENT_PROFILE:labels.lnrCode7778'),
  lnrCode719: t('AGENT_PROFILE:labels.lnrCode719'),
});

export const getMVPWorkDataTranslations = (
  t: TFunction
): Partial<Record<keyof MVPProfileWorkData, string>> => ({
  departmentAddress: t('AGENT_PROFILE:labels.departmentAddress'),
  department: t('AGENT_PROFILE:labels.department'),
  departmentCode: t('AGENT_PROFILE:labels.departmentCode'),
  managerName: t('AGENT_PROFILE:labels.managerName'),
});

export const getPersonalDataTranslations = (
  t: TFunction
): Partial<Record<keyof ProfilePersonalData, string>> => ({
  fio: t('AGENT_PROFILE:labels.fio'),
  gender: t('AGENT_PROFILE:labels.gender'),
  rgsCode: t('AGENT_PROFILE:labels.rgsCode'),
  birthDate: t('AGENT_PROFILE:labels.birthDate'),
  passportSeriesNumber: t('AGENT_PROFILE:labels.passportSeriesNumber'),
  codeDepartment: t('AGENT_PROFILE:labels.departmentCode'),
  nameDepartment: t('AGENT_PROFILE:labels.passportIssuedBy'),
  dateIssue: t('AGENT_PROFILE:labels.issueDate'),
  snils: t('AGENT_PROFILE:labels.snils'),
  inn: t('AGENT_PROFILE:labels.inn'),
});

export const getContactsTranslations = (t: TFunction) => ({
  phone: t('AGENT_PROFILE:labels.phone'),
  email: t('AGENT_PROFILE:labels.email'),
  website: t('AGENT_PROFILE:labels.website'),
});

export const getAddressTranslations = (t: TFunction) => ({
  address: t('AGENT_PROFILE:labels.address'),
  actualAddress: t('AGENT_PROFILE:labels.actualAddress'),
});

export const getGenderLabels = (t: TFunction) => ({
  [Gender.MALE]: t('COMMON:genders.male'),
  [Gender.FEMALE]: t('COMMON:genders.female'),
});
